import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  fetchDataFlavorsRequest,
} from "./../store/actions";
import { useAppDispatch } from "core/hooks/useAppDispatch";

export const useFetchFlavors = () => {
  const dispatch = useAppDispatch()
  const flavors = useSelector((state: any) => state.Ingredients.flavors);

  useEffect(() => {
    dispatch(fetchDataFlavorsRequest())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return flavors
}
